/**
 * App-wide design tokens — change fonts / type here once.
 * Consumed by: global.css, muiTheme.js, index.js (Google Fonts loader).
 *
 * To switch the product font later:
 *  1. Update `FONTS.sans` + `FONTS.googleFontsHref` below
 *  2. Keep `global.css` in sync (same family names in --font-sans)
 *  3. Restart / hard-refresh the browser
 */

export const FONTS = {
  /** Primary UI font stack */
  sans: `"Inter", "Segoe UI", system-ui, -apple-system, sans-serif`,

  /** Code / monospace (subject codes, logs) */
  mono: `"JetBrains Mono", "SF Mono", ui-monospace, Menlo, Consolas, monospace`,

  /**
   * Google Fonts stylesheet — must include every family used above.
   * https://fonts.google.com
   */
  googleFontsHref:
    "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap",

  letterSpacing: "-0.011em",
  letterSpacingTight: "-0.028em",
};

/** Convenience aliases for inline React styles */
export const FONT = {
  family: FONTS.sans,
  mono: FONTS.mono,
  letterSpacing: FONTS.letterSpacing,
};

/**
 * Inject the Google Fonts <link> once (single source with FONTS.googleFontsHref).
 */
export function loadAppFonts() {
  if (typeof document === "undefined") return;
  const id = "ap-google-fonts";
  if (document.getElementById(id)) return;
  const preconnect1 = document.createElement("link");
  preconnect1.rel = "preconnect";
  preconnect1.href = "https://fonts.googleapis.com";
  document.head.appendChild(preconnect1);

  const preconnect2 = document.createElement("link");
  preconnect2.rel = "preconnect";
  preconnect2.href = "https://fonts.gstatic.com";
  preconnect2.crossOrigin = "anonymous";
  document.head.appendChild(preconnect2);

  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = FONTS.googleFontsHref;
  document.head.appendChild(link);
}

export default FONTS;
